var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCiSortAscending = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 25.5H15M6 18H19.5M27 16.5V28.5M27 28.5L31.5 24M27 28.5L22.5 24M6 10.5H24",
  stroke: "#3988F9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCiSortAscending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ci_sort-ascending.2e212672.svg";
export { ForwardRef as ReactComponent };